import React from 'react';

interface ConfidenceBadgeProps {
  value: number;
  showLabel?: boolean;
}

export default function ConfidenceBadge({ value, showLabel = true }: ConfidenceBadgeProps) {
  const tier = value >= 75 ? 'high' : value >= 55 ? 'medium' : 'low';
  const config = {
    high: { label: 'ÉLEVÉ', classes: 'bg-positive-subtle text-positive border-positive/30' },
    medium: { label: 'MOYEN', classes: 'bg-warning-subtle text-warning border-warning/30' },
    low: { label: 'FAIBLE', classes: 'bg-negative-subtle text-negative border-negative/30' },
  };
  const { label, classes } = config[tier];

  return (
    <span className={`status-badge border font-mono-data ${classes}`}>
      {value}%{showLabel && ` ${label}`}
    </span>
  );
}